(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var targets = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var pending = Array.prototype.slice.call(targets);

    /* threshold à 0 et pas à 0.12 : la grille produits est un seul élément
       observé, souvent bien plus haute que l'écran. Exiger 12 % de sa surface
       revenait à exiger plusieurs écrans de défilement : la page de collection
       s'affichait vide à l'arrivée et les produits n'apparaissaient qu'après
       un premier scroll. */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    function reveal(el) {
      el.classList.add('is-visible');
      var idx = pending.indexOf(el);
      if (idx !== -1) pending.splice(idx, 1);
    }

    targets.forEach(function (el) { observer.observe(el); });

    /* Filet de sécurité : un saut de défilement instantané (touche Fin,
       ancre #, scrollIntoView, ou un défilement trop rapide sur trackpad)
       peut faire passer un élément de « pas encore visible » à « déjà passé »
       sans jamais déclencher l'intersection — il reste alors bloqué à
       opacity:0. On revient vérifier à la main, après chaque défilement
       (débounceé) et un court instant après le chargement, tout élément
       encore en attente dont le haut est déjà entré dans l'écran — y compris
       ceux situés au-dessus du viewport (bas négatif = déjà scrollé passé). */
    function sweepPending() {
      if (!pending.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      pending.slice().forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < vh && rect.bottom > 0) {
          reveal(el);
          observer.unobserve(el);
        } else if (rect.bottom <= 0) {
          /* déjà entièrement au-dessus de l'écran : on l'a manqué, on révèle quand même */
          reveal(el);
          observer.unobserve(el);
        }
      });
    }

    var sweepTimer = null;
    function scheduleSweep() {
      if (sweepTimer) return;
      sweepTimer = setTimeout(function () {
        sweepTimer = null;
        sweepPending();
      }, 120);
    }

    window.addEventListener('scroll', scheduleSweep, { passive: true });
    window.addEventListener('resize', scheduleSweep);
    setTimeout(sweepPending, 400);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
